import {
    Box,
    Button,
    Grid,
    makeStyles,
    TextField,
    Checkbox
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React from "react";
import {
    Controller,
    useFieldArray,
    useWatch
} from "react-hook-form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import styled from "styled-components";
import FormControlLabel from "@material-ui/core/FormControlLabel";


const productOptionDefaultValue = {
    "optionTc": "",
    "optionEn": "",
    "orgPrice": null,
    "price": null,
    "quantitySold": null,
    "quantityStock": null,
    "outOfStock": false
};

const useStyles = makeStyles((theme) => ({
    productOptionBlk: {
        background: "#FFFFFF",
        marginBottom: "20px",
    },
    productOptionBlkHeader: {
        background: "#EDEEF0",
        borderLeft: "3px solid #9D3030",
        fontWeight: "bold",
        fontSize: "14px",
        lineHeight: "16px",
        padding: "12px 13px",
    },
    productOptionBlkBody: {
        border: "1px solid #CCCCCC",
        borderTop: "0px",
        padding: "20px 13px",
    },
    deleteBtn: {
        margin: "0",
        padding: "0",
        minWidth: "initial",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
}));

const PriceTag = styled.span`
  color: #CCCCCC;
  transform: scale(0.8);
`;

const ProductOptionBlock = ({
    control,
    index,
    classes,
    disabled,
    remove,
    data,
    setValue,
    getValues
}) => {

    return (
        <>
            <Grid
                container
                className={classes.productOptionBlkHeader}
                xs={12}
                alignItems="center"
                justify="space-between"
            >
                <span>Product Option {index + 1}</span>
                {disabled || (
                    <Button className={classes.deleteBtn}
                        onClick={() => remove(index)}>
                        <Close style={{
                            fontSize: "14px",
                            lineHeight: "16px"
                        }} />
                    </Button>
                )}
            </Grid>

            <Box className={classes.productOptionBlkBody}>
                <Grid container spacing={3}
                    direction="column">
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                // defaultValue={data?.option.options[index]}
                                name={`options.optionDtl[${index}].optionEn`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Option Name (English)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].optionEn`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                // defaultValue={data?.option.options[index]}
                                name={`options.optionDtl[${index}].optionTc`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Option Name (Traditional Chinese)"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].optionTc`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                    </Grid>

                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                name={`options.optionDtl[${index}].orgPrice`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Original Price"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        type='number'
                                        InputProps={{
                                            startAdornment: (
                                                <PriceTag>HK$</PriceTag>
                                            ),
                                        }}
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].orgPrice`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name={`options.optionDtl[${index}].price`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Price"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        type='number'
                                        InputProps={{
                                            startAdornment: (
                                                <PriceTag>HK$</PriceTag>
                                            ),
                                        }}
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].price`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>


                    </Grid>


                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <Controller
                                name={`options.optionDtl[${index}].quantityStock`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Stock"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].quantityStock`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name={`options.optionDtl[${index}].quantitySold`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <TextField
                                        label="Sold"
                                        variant="outlined"
                                        margin="dense"
                                        className={classes.textInput}
                                        fullWidth
                                        error={!!error}
                                        helperText={error ? error.message : ""}
                                        value={value}
                                        onChange={(event) => {
                                            setValue(`options.optionDtl[${index}].quantitySold`, event.target.value);
                                        }}
                                        {...rest}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name={`options.optionDtl[${index}].outOfStock`}
                                control={control}
                                render={({
                                    field: {
                                        value,
                                        onChange,
                                        ...rest
                                    },
                                    fieldState: { error },
                                }) => (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                type="checkbox"
                                                color="primary"
                                                checked={value}
                                                {...rest}
                                                onChange={(event) => {
                                                    console.log(event.target.checked);
                                                    setValue(
                                                        `options.optionDtl[${index}].outOfStock`,
                                                        event.target.checked
                                                    );
                                                }}
                                            />
                                        }
                                        label="Out of stock"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                </Grid>
            </Box>
        </>
    );
};

export default function ProductOptionSections(props) {

    const {
        control,
        setValue,
        getValues,
        disabled,
    } = props;

    const classes = useStyles();

    const { fields, append, remove } = useFieldArray({
        control,
        name: "options.optionDtl"
    })

    return (
        <>
            {fields.map((data, index) => (
                <div className={classes.productOptionBlk}
                    key={data.id}>
                    <ProductOptionBlock
                        {...{
                            control,
                            index,
                            classes,
                            disabled,
                            remove,
                            data,
                            setValue,
                            getValues,
                        }}
                    />
                </div>
            ))}
            {disabled || (
                <Button
                    type="button"
                    onClick={() => {
                        append(productOptionDefaultValue);
                    }}
                    style={{
                        color: "#306F9D",
                        margin: "5px 0",
                    }}
                >
                    <AddCircleIcon />
                    Add Option
                </Button>
            )}
        </>
    );
}